/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-06 18:29:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-03-24 18:02:58
 */
import http from "@/api";

export const fetchStrategySystemImpression = () => {
	return http.get("/team/dashboard");
};
